
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Axios from 'axios';
import { DIV } from 'src/components/CustomStyledComponents';
import HeaderPage from 'src/components/header/HeaderPage';
import NavbarHeader from 'src/components/header/NavbarHeader';
import LoadingWrapper from 'src/components/Loading/LoadingWrapper';
import withCotizacion from 'src/HOC/withCotizacion';
import usePageValidation from 'src/hooks/usePageValidation';
import usePaginaPago from 'src/reducers/PaginaPago/usePaginaPago';
import PlaceToPay from './ButtonsPago/PlaceToPay';
import usePtp from 'src/hooks/usePtp';
import TerminosCondicionesCheck from 'src/pages/PaginaPago/TerminosCondicionesCheck';
import { URL_EDIT_VIGENCIA_COTIZACION } from 'src/parametros';
import franquicias from 'src/assets/img/franquicias.png'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
// import './styles.scss';
const TAG = "cambiosuscripcionptp"

const CambioSuscripcionPtp = ({ cotizacion, idCotizacion, ...props }) => {

  const { loading, getPagosPendientes } = usePtp();
  const { loadingState } = usePaginaPago();
  const { execEvent, isLoadingCallbacks } = usePageValidation(TAG);
  const textos = cotizacion?.configuracion?.textos?.[TAG] ?? ""
  const [pageProps, setPageProps] = useState({
    titleValues: textos?.titulo || 'Cambio de tarjeta suscrita ',
    subtitleValues: textos?.subtitulo ?? "",
    labelPagar: "",
    moneda: '$',
    showValues: true,
    goBack: `/newPaginaCompra/${idCotizacion}`,
  });

  const [listaPP, setlistaPP] = useState([])


  const pagosPendientes = async () => {
    const res = await getPagosPendientes();
    setlistaPP(res);
  }

  const init = useCallback(async () => {

    await execEvent('initCallback', { pageProps, setPageProps });

    const body = {
      idCotizacion,
      fecha: new Date().toDateString(),
    };

    const { data } = await Axios.post(URL_EDIT_VIGENCIA_COTIZACION, JSON.stringify(body));
    console.log("data", data)

  }, [isLoadingCallbacks]);

  const botonesPagoComponent = useMemo(() => {
    const filterNoNull = (item) => item !== null;
    const filterByTipo = (tipo: string) => (item) => item.tipo === tipo;
    const filterOnShow = (flujo) => (item) => {
      if (!!item?.onShow) {
        const show = item?.onShow?.find(data => `${data}` === `${flujo}`)
        console.log("resp", show, item)
        if (show) return item
      } else return item
    }

    const mapper = (metodo, index: number) => {

      const TIPO_BOTONES = { placetopay: PlaceToPay }
      const Component = TIPO_BOTONES[metodo.codCore]
      console.log("Component", Component)
      return Component ? <Component key={index} {...metodo} /> : null
    };

    const botones: React.FC[] = cotizacion?.metodosPago
      .map(mapper)
      .filter(filterNoNull);

    const enlaces: React.FC[] = cotizacion?.metodosPago
      .filter(filterByTipo('enlace'))
      .map(mapper)
      .filter(filterNoNull);

    return { botones, enlaces };
  }, [cotizacion?.metodosPago]);

  useEffect(() => {
    pagosPendientes()
    // guardarLead(idCotizacion, `PAGINA_PAGO__INGRESO`);
    init();
  }, []);
  return (
    <LoadingWrapper loading={loading || loadingState.loading}>
      <DIV stylePath="" className="container-fluid container-page">
        <NavbarHeader showBack={false} goBack={pageProps.goBack} />
        <HeaderPage progreso={70} />
        <div className="row justify-content-center">
          <div className="col-12 text-center mt-3">
            <h4 className="titulo font-weight-bold">{pageProps.titleValues}</h4>
            <p>{pageProps.subtitleValues}</p>
          </div>
          <div className="col-11 col-md-6 col-xl-6  text-center">
            {pageProps.showValues && (
              <React.Fragment>
                {pageProps.labelPagar}
                {/* <Impuestos impuestos={pageProps.impuestos} moneda={cotizacion?.moneda} /> */}
              </React.Fragment>
            )}
          </div>
        </div>
        <div className="row justify-content-center my-3">
          <div className="col-11 col-md-7 mb-3" >
            <h5> <p className="text-center">Seleccione el botón de pagos respectivo para poder cambiar su suscripción</p></h5>
            {listaPP.length > 0 &&
              <div className="card">
                <DataTable value={listaPP} header="Pagos pendientes" className="p-datatable-sm">
                  <Column field="fechaVencimiento" header="Fecha de Vencimiento"></Column>
                  <Column field="montoPago" header="Monto"></Column>
                </DataTable>
              </div>
            }
          </div>
        </div>
        <div className="row justify-content-center my-3">

          <TerminosCondicionesCheck />
        </div>
        <div className="row justify-content-center my-3">
          <div className="col-md-6 mt-3">
            <div
              className="row justify-content-center py-4"
              style={{ backgroundColor: '#fafafa', }}
            >
              <>{botonesPagoComponent.botones}</>
            </div>
          </div>
        </div>
        <div className="row justify-content-center my-3">
          <div className="col-12" />
            <div className="col-md-6 d-flex flex-row justify-content-center" >
              <img className="img-fluid" src={franquicias} alt="img-franquicias" style={{ maxHeight: 50 }} />
            </div>
        </div>
      </DIV>
    </LoadingWrapper >
  );
};

export default withCotizacion(CambioSuscripcionPtp);
